export const FLOW_ID = {
  PROVIDER: 'provider',
  BILLING: 'billing',
  VENDOR: 'vendor',
  API_MARKETPLACE_PROVIDER: 'API marketplace provider',
  API_MARKETPLACE_PROVIDER_TECHNICIAN: 'API marketplace provider technician',
  API_MARKETPLACE_BILLING: 'API marketplace billing',
  API_MARKETPLACE_VENDOR: 'API marketplace vendor',
  API_MARKETPLACE_BILLING_TECHNICIAN: 'API marketplace billing technician',
  API_MARKETPLACE_VENDOR_TECHNICIAN: 'API marketplace vendor technician',
};
